import React from "react";
import Context from "../../Context";
import Blocker from "./Blocker";
import ElementCatalogTree from "../Layout/Element/ElementCatalogTree";
import ElementList from "../Layout/Element/ElementList";
import BsModal from "./BsModal";
import DefaultNotFound from "./DefaultNotFound";
import SuperSelect from "./SuperSelect";
import EssenceReferenceShipEdit from "../Essence/EssenceReferenceShipEdit";
import Searchbox from "./Searchbox";
import Modal from "./Modal";

export default class ElementPicker extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      specId: this.props.specId || "any",
      shipId: this.props.shipId,

      checkedElements: [],

      catalogSearchText: "",

      pending: false,
      catalogItems: null,
      catalogItemsSearchDefault: [
        {
          lstr: "(",
          field: "statetypecode",
          compare: "EQL",
          value: "enabled",
        },
        {
          field: "typecode",
          compare: "EQL",
          value: "ship.specification",
          rstr: ")",
        },
      ],
    };
  }

  componentDidMount() {
    this.loadCatalog();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.shipId !== this.props.shipId) {
      this.onShipChange(this.props.shipId);
    }
  }

  loadCatalog = async () => {
    let { catalogItemsSearchDefault, shipId } = this.state;
    this.setState({ pending: true });

    let shipItem = {};
    if (shipId && shipId !== "any") {
      shipItem = await this.context.api.q("/ship/get", {
        id: shipId,
      });
    }
    const projectId = shipItem.project || null;

    let search = catalogItemsSearchDefault.slice();
    search.push({
      field: "project",
      compare: "EQL",
      value: projectId,
    });

    let catalogItems = await this.context.api.qoo(
      `/specification/tree`,
      {
        project: projectId,
        ship: shipItem.id,
        filter: { visible: true, statetypecode: "enabled" },
      },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );
    this.setState({ pending: false, catalogItems, checkedElements: [] });
  };

  onTreeClick = (item) => {
    this.setState({ specId: item.id });
  };

  onElementsSelect = () => {
    this.props.onElementPick(this.state.checkedElements);
    this.setState({ checkedElements: [] });
    this.props.onClose();
  };
  onElementPick = (item) => {
    this.props.onElementPick(item);
    this.props.onClose();
  };
  onElementCheck = (item) => {
    this.setState((state) => {
      let checkedElements = state.checkedElements;
      if (checkedElements.includes(item.id)) {
        checkedElements.splice(checkedElements.indexOf(item.id), 1);
      } else {
        checkedElements.push(item.id);
      }
      return { checkedElements };
    });
  };
  onShipChange = (shipId) => {
    this.setState(
      {
        shipId: shipId,
        specId: this.props.specId || "any",
        customListKey: this.context.key(),
      },
      () => this.loadCatalog()
    );
  };
  onCatalogSearch = (v) => {
    this.setState({ catalogSearchText: v });
  };
  render() {
    const { multiple, allowShipChange } = this.props;
    const { shipId, specId, catalogItems, catalogSearchText } = this.state;

    let extraListButtons = null;
    if (multiple && this.state.checkedElements.length) {
      extraListButtons = (
        <button
          onClick={this.onElementsSelect}
          title="Выбрать"
          className="ml-2 btn btn-light-primary"
        >
          <i className="fa fa-mail-forward"></i>
          <label className="label label-primary">
            {this.state.checkedElements.length}
          </label>
        </button>
      );
    }

    const ShipSelect = allowShipChange ? (
      <div className="mb-2">
        <SuperSelect
          grey
          defaultValue={shipId}
          onChange={this.onShipChange}
          essence="ship"
          placeholder="Выберите судно..."
          nameField="name"
          idField="id"
          isClearable
          reference={{
            title: "Суда",
            essence: "ship",
            showDescription: true,
            showType: true,
            itemEditor: (itemEditorProps) => (
              <EssenceReferenceShipEdit {...itemEditorProps} />
            ),
          }}
        />
      </div>
    ) : null;

    let shipNotFound = !shipId && !allowShipChange;

    let displayCatalogItems = {};
    if (catalogSearchText) {
      Object.entries(catalogItems).forEach(([id, item]) => {
        let searchReg = new RegExp(
          this.context.api.regexEscape(catalogSearchText),
          "i"
        );
        if (item.label.search(searchReg) > -1) {
          displayCatalogItems[id] = { ...item, node: null, level: 1 };
        }
      });
    } else {
      displayCatalogItems = catalogItems;
    }

    const ModalComponent = this.props.keepModal ? Modal : BsModal;

    return (
      <ModalComponent center xl {...this.props}>
        <Blocker on={this.state.pending}>
          {shipNotFound && <DefaultNotFound message="Не выбрано судно" />}
          {allowShipChange && !shipId && ShipSelect}
          {shipId && (
            <div className="row">
              {!this.props.specId && (
                <div className="col-lg-5 border-right pr-3">
                  {ShipSelect}
                  {this.state.catalogItems ? (
                    <div>
                      <div className="mb-3">
                        <Searchbox
                          placeholder="Поиск в структуре..."
                          onSearch={this.onCatalogSearch}
                          timeout={500}
                        />
                      </div>
                      <div
                        onClick={() => this.onTreeClick({ id: "any" })}
                        className={`cursor-pointer d-block text-dark p-1  ${
                          specId === "any" && "bg-light-mui"
                        }`}
                      >
                        <i className="fa fa-list mr-3"></i> Все
                      </div>

                      <ElementCatalogTree
                        items={displayCatalogItems}
                        onTreeClick={this.onTreeClick}
                        specId={specId}
                        {...this.props}
                      />
                    </div>
                  ) : null}
                </div>
              )}
              <div className="col-lg">
                {shipId && specId && (
                  <ElementList
                    shipId={shipId}
                    specId={specId}
                    customListKey={this.state.customListKey}
                    onElementPick={!multiple ? this.onElementPick : null}
                    onElementCheck={multiple ? this.onElementCheck : null}
                    checkedElements={this.state.checkedElements}
                    extraButtons={extraListButtons}
                  />
                )}
              </div>
            </div>
          )}
        </Blocker>
      </ModalComponent>
    );
  }
}
